<div class="dashboard-container">
    <div class="row">
        <div class="col-md-4">
            <div class="mb-3">
                <!-- <dropdown [caption]="'Financial Year'" [data]="financialYearList" [valueField]="'Post_Id'"
                    [textField]="'Post_Name'" [(ngModel)]="entity.FinancialYear" [filterable]="true" [formData]="entity"
                    [fieldName]="'PostId'" ngDefaultControl>
                </dropdown> -->
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="dashboard-placeholder">
                <div class="dashboard-header">
                    <span>Summary</span>
                </div>
                <div class="dashboard-contain row">
                    <div class="col-md-2">
                        <div class="count-placeholder total-candidates">
                            <div class="count-spec">32578</div>
                            <div class="count-caption">Total Candidates</div>
                        </div>
                    </div>
                    <div class="col-md-2">
                    <div class="count-placeholder total-candidates-l1">
                        <div class="count-spec">253</div>
                        <div class="count-caption">Passed - Level 1</div>
                    </div>
                    </div>
                    <div class="col-md-2">
                    <div class="count-placeholder total-candidates-l2">
                        <div class="count-spec">150</div>
                        <div class="count-caption">Passed - Level 2</div>
                    </div>
                    </div>
                    <div class="col-md-2">
                    <div class="count-placeholder total-candidates-l3">
                        <div class="count-spec">58</div>
                        <div class="count-caption">Passed - Level 3</div>
                    </div>
                    </div>
                    <div class="col-md-2">
                    <div class="count-placeholder total-candidates-selected">
                        <div class="count-spec">1250</div>
                        <div class="count-caption">Selected Candidates</div>
                    </div>
                    </div>
                    <div class="col-md-2">
                    <div class="count-placeholder total-candidates-bgvp">
                        <div class="count-spec">567</div>
                        <div class="count-caption">BGV Pending</div>
                    </div>
                    </div>
                    <div class="col-md-2">
                    <div class="count-placeholder total-candidates-tv">
                        <div class="count-spec">567</div>
                        <div class="count-caption">Total Vacancy</div>
                    </div>
                    </div>
                    <div class="col-md-2">
                    <div class="count-placeholder total-candidates-short">
                        <div class="count-spec">567</div>
                        <div class="count-caption">Shortlisted</div>
                    </div>
                    </div>
                    <div class="col-md-2">
                    <div class="count-placeholder total-candidates-pend">
                        <div class="count-spec">567</div>
                        <div class="count-caption">Pending</div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4">
            <div class="dashboard-placeholder">
                <div class="dashboard-header">
                    <span>Birthday</span>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <div class="dashboard-placeholder">
                <div class="dashboard-header">
                    <span>New Hires</span>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <div class="dashboard-placeholder">
                <div class="dashboard-header">
                    <span>Favorites</span>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4">
            <div class="dashboard-placeholder">
                <div class="dashboard-header">
                    <span>Quick Links</span>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <div class="dashboard-placeholder">
                <div class="dashboard-header">
                    <span>Request For Approval</span>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <div class="dashboard-placeholder">
                <div class="dashboard-header">
                    <span>Attendance</span>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-4">
            <div class="dashboard-placeholder">
                <div class="dashboard-header">
                    <span>Announcements</span>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <div class="dashboard-placeholder">
                <div class="dashboard-header">
                    <span>Leave Report</span>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <div class="dashboard-placeholder">
                <div class="dashboard-header">
                    <span>Upcoming Holidays</span>
                </div>
            </div>
        </div>
    </div>

</div>